import api from "./api";

function adminUrl(path) {
    const baseURL = api.defaults.baseURL || window.location.origin;
    return new URL(`../admin/platform-services/${String(path || "").replace(/^\/+/, "")}`, baseURL).toString();
}

function dataOf(response) {
    return response?.data?.data ?? response?.data ?? null;
}

export const fetchPlatforms = async () => dataOf(await api.get(adminUrl(""))) || [];
export const fetchCrmRegistry = async () => dataOf(await api.get(adminUrl("crm/registry"))) || {};
export const fetchCrmWorkspaces = async () => dataOf(await api.get(adminUrl("crm/workspaces"))) || [];
export const fetchServiceClients = async () => dataOf(await api.get(adminUrl("crm/service-clients"))) || [];
export const createServiceClient = async (payload) => dataOf(await api.post(adminUrl("crm/service-clients"), {data: payload}));
export const updateServiceClient = async (documentId, payload) => dataOf(await api.patch(adminUrl(`crm/service-clients/${documentId}`), {data: payload}));
export const fetchServiceApiKeys = async (documentId) => dataOf(await api.get(adminUrl(`crm/service-clients/${documentId}/api-keys`))) || [];
export const createServiceApiKey = async (documentId, payload) => dataOf(await api.post(adminUrl(`crm/service-clients/${documentId}/api-keys`), {data: payload}));
export const rotateServiceApiKey = async (documentId, payload) => dataOf(await api.post(adminUrl(`crm/api-keys/${documentId}/rotate`), {data: payload}));
export const revokeServiceApiKey = async (documentId) => dataOf(await api.post(adminUrl(`crm/api-keys/${documentId}/revoke`), {data: {}}));
export const fetchTenantBindings = async (documentId) => dataOf(await api.get(adminUrl(`crm/service-clients/${documentId}/bindings`))) || [];
export const createTenantBinding = async (documentId, payload) => dataOf(await api.post(adminUrl(`crm/service-clients/${documentId}/bindings`), {data: payload}));
export const updateTenantBinding = async (documentId, payload) => dataOf(await api.patch(adminUrl(`crm/bindings/${documentId}`), {data: payload}));
